// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Col, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import AbsenceReasonsForm from "./absence-reasons-form";
import { formatDateTime } from "@transformers/date";
import type { AbsenceReason } from "@modules/service/reducer/absence-reasons/types";

type OwnProps = $Exact<{
  schema: ?Object,
  data: Object,
  onSubmit: (data: AbsenceReason) => void,
  onClose: () => void,
  providerId: number,
}>;

type Props = $Exact<{ ...OwnProps, ...PropsFromLocalize }>;

export class AbsenceReasonsEditModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get data() {
    return {
      ...this.props.data,
      ...this.props.data.content,
      nurseTransferEligibility: "ALWAYS",
      nurseTransferEligibilityAbsenceDuration: null,
    };
  }

  get updatedBy() {
    if (!this.data.updatedBy) {
      return this.props.t("N/A");
    }

    return `${this.data.updatedBy.firstName || ""} ${this.data.updatedBy.lastName || ""}`;
  }

  get updatedAt() {
    return this.data.updatedAt ? formatDateTime(this.data.updatedAt) : this.props.t("N/A");
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onClose}>
          {this.props.t("EDIT_ABSENCE_REASON_MODAL_TITLE", { providerId: this.props.providerId })}
        </ModalHeader>
        <ModalBody>
          <div className="mb-4 pl-2">
            <div className="d-flex gap-20 mb-1">
              <span className="text-color-charcoal">{`${this.props.t("LAST_UPDATED")}:`}</span>
              <span className="font-weight-bold">{this.updatedAt}</span>
            </div>
            <div className="d-flex gap-17 b-line pb-4">
              <span className="text-color-charcoal">{`${this.props.t("LAST_UPDATED_BY")}:`}</span>
              <span className="font-weight-bold">{this.updatedBy}</span>
            </div>
          </div>
          {this.props.schema && this.data && (
            <AbsenceReasonsForm
              ref={this.formRef}
              data={this.data}
              schema={this.props.schema}
              onSubmit={this.handleSubmit}
            />
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AbsenceReasonsEditModal);
